import {protectedWhatsAppFetch} from "./services/protectedWhatsApp";
import {useAccess} from "./access/useAccess";
import {clinicSettingsPayload} from "./access/settings";
import {connectGoogleCalendar,disconnectGoogleCalendar,importGoogleCalendar} from "./services/googleCalendarAccess";
import {
  useEffect,
  useState,
  useRef
} from "react";

import { auth } from "./firebase";

import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword
} from "firebase/auth";

import {
  doc,
  updateDoc,
  onSnapshot,
  getDoc
} from "./access/firestore";

import { db }
  from "./firebase";

import {
  useClinic
} from "./context/ClinicContext";

import {
  ref,
  uploadBytes,
  getDownloadURL
} from "firebase/storage";

import { storage }
  from "./firebase";

import {
  useNotifications
} from "./notifications/NotificationProvider";

import {
  FaEye,
  FaEyeSlash
} from "react-icons/fa";

import { requestVexaConfirm } from "./notifications/dialogService";

import { QRCodeSVG }
  from "qrcode.react";

import ProceduresSettings from "./components/settings/ProceduresSettings";

import HistoriaClinicaSettings from "./components/settings/HistoriaClinicaSettings";

import ConsentimientosSettings from "./components/settings/ConsentimientosSettings";

import MedicationsSettings from "./components/settings/MedicationsSettings";

import ComunicacionCampanasPanel
  from "./components/settings/ComunicacionCampanasPanel";

import AdvancedClinicSettings
  from "./components/settings/AdvancedClinicSettings";

import ConnectionsSettings
  from "./components/settings/ConnectionsSettings";

import {
  MessageCircle,
  CalendarDays,
  CheckCircle2,
  CircleOff,
  Link2,
  Unplug,
  Download,
  AlertTriangle,
  QrCode,
  Settings2,
  Search,
  ChevronRight,
  Check,
  Activity,
  ShieldCheck,
  Building2,
  ClipboardList,
  FileSignature,
  Pill,
  PlugZap,
  Stethoscope,
  SlidersHorizontal
} from "lucide-react";

const SETTINGS_NAV_GROUPS = [
  {
    label: "Centro de control",
    items: [
      {
        key: "overview",
        label: "Resumen",
        description: "Estado general y accesos rápidos",
        icon: Settings2
      },
      {
        key: "control",
        label: "Configuración completa",
        description: "Controla todos los módulos del consultorio",
        icon: SlidersHorizontal
      }
    ]
  },
  {
    label: "Operación",
    items: [
      {
        key: "procedures",
        label: "Catálogo de procedimientos",
        description: "Precios, duración y categorías",
        icon: Stethoscope
      }
    ]
  },
  {
    label: "Experiencia clínica",
    items: [
      {
        key: "historiaClinica",
        label: "Historia clínica",
        description: "Campos y estructura del expediente",
        icon: ClipboardList
      },
      {
        key: "consentimientos",
        label: "Consentimientos",
        description: "Documentos y firmas informadas",
        icon: FileSignature
      },
      {
        key: "medicamentos",
        label: "Medicamentos",
        description: "Catálogo y posología",
        icon: Pill
      }
    ]
  },
  {
    label: "Comunicación",
    items: [
      {
        key: "integraciones",
        label: "Conexiones",
        description: "WhatsApp y calendarios conectados",
        icon: PlugZap
      },
      {
        key: "comunicacion",
        label: "Campañas y plantillas",
        description: "Automatiza recordatorios, confirmaciones y seguimientos",
        icon: MessageCircle
      }
    ]
  },
  {
    label: "Cuenta y sistema",
    items: [
      {
        key: "cuenta",
        label: "Cuenta y seguridad",
        description: "Firma, contraseña y acceso",
        icon: ShieldCheck
      },
      {
        key: "sistema",
        label: "Sistema",
        description: "Estado técnico y dispositivos",
        icon: Activity
      }
    ]
  }
];

const SETTINGS_ITEMS = SETTINGS_NAV_GROUPS.flatMap(group => group.items);

export default function SettingsPanel() {
  const {can}=useAccess();


  const {
    notify
  } = useNotifications();

  const {
    clinicId,
    clinicData
  } = useClinic();

  const comunicacionSaveRef = useRef(null);

  const [
    form,
    setForm
  ] = useState({

    nombreClinica:"",
    telefono:"",
    email:"",
    RFC:"",
    direccion:{
      calle:"",
      numeroExterior:"",
      numeroInterior:"",
      codigoPostal:"",
      colonia:"",
      ciudad:"",
      estado:"",
      pais:"México"
    },
    logoURL:"",

    logoBase64:"",

    horaApertura:"09:00",

    horaCierre:"18:00",

    intervaloAgenda:"15",

    defaultAppointmentDuration:"60",

    horariosLaborales: {

  lunes: {
    activo: true,
    apertura: "09:00",
    comidaInicio: "14:00",
    comidaFin: "15:00",
    cierre: "18:00"
  },

  martes: {
    activo: true,
    apertura: "09:00",
    comidaInicio: "14:00",
    comidaFin: "15:00",
    cierre: "18:00"
  },

  miercoles: {
    activo: true,
    apertura: "09:00",
    comidaInicio: "14:00",
    comidaFin: "15:00",
    cierre: "18:00"
  },

  jueves: {
    activo: true,
    apertura: "09:00",
    comidaInicio: "14:00",
    comidaFin: "15:00",
    cierre: "18:00"
  },

  viernes: {
    activo: true,
    apertura: "09:00",
    comidaInicio: "14:00",
    comidaFin: "15:00",
    cierre: "18:00"
  },

  sabado: {
    activo: true,
    apertura: "09:00",
    comidaInicio: "",
    comidaFin: "",
    cierre: "14:00"
  },

  domingo: {
    activo: false,
    apertura: "09:00",
    comidaInicio: "",
    comidaFin: "",
    cierre: "14:00"
  }

},

    whatsappEnabled:false,

    whatsappBusinessName:"",

    whatsappNumber:"",

    notifications: {

      reminder24h: true,

      reminder2h: false,

      autoConfirm: true,

      cancelledAppointment: true,

      whatsappMessages: true

    },

    timeZone:
      Intl.DateTimeFormat()
        .resolvedOptions()
        .timeZone,

  });

  const [
    saving,
    setSaving
  ] = useState(false);


  const [
    whatsappStatus,
    setWhatsappStatus
  ] = useState(null);

  const [
    googleCalendarStatus,
    setGoogleCalendarStatus
  ] = useState({
    connected: false,
    email: ""
  });

  const [
    importandoGoogle,
    setImportandoGoogle
  ] = useState(false);

  const [
    resultadoImportacion,
    setResultadoImportacion
  ] = useState(null);

  const [
    vpsOnline,
    setVpsOnline
  ] = useState(false);

  const [
    colonias,
    setColonias
  ] = useState([]);

  // =========================
  // LOAD DATA
  // =========================

  useEffect(() => {

    if (!clinicData)
      return;

    setForm({

      nombreClinica:
        clinicData.nombreClinica || "",

      telefono:
        clinicData.telefono || "",

      email:
        clinicData.email || "",

      RFC:
        clinicData.RFC || "",

      direccion:
        clinicData.direccion || {

          calle:"",
          numeroExterior:"",
          numeroInterior:"",
          codigoPostal:"",
          colonia:"",
          ciudad:"",
          estado:"",
          pais:"México"

        },

      logoURL:
          clinicData.logoURL || "",

      logoBase64:
          clinicData.logoBase64 || "",

      horaApertura:
        clinicData.horaApertura || "09:00",

      horaCierre:
        clinicData.horaCierre || "18:00",

      intervaloAgenda:
        clinicData.intervaloAgenda || "15",

      defaultAppointmentDuration:
        clinicData
          .defaultAppointmentDuration
          || "60",

      horariosLaborales:
        clinicData.horariosLaborales || {

          lunes: {
            activo: true,
            apertura: "09:00",
            comidaInicio: "14:00",
            comidaFin: "15:00",
            cierre: "18:00"
          },

          martes: {
            activo: true,
            apertura: "09:00",
            comidaInicio: "14:00",
            comidaFin: "15:00",
            cierre: "18:00"
          },

          miercoles: {
            activo: true,
            apertura: "09:00",
            comidaInicio: "14:00",
            comidaFin: "15:00",
            cierre: "18:00"
          },

          jueves: {
            activo: true,
            apertura: "09:00",
            comidaInicio: "14:00",
            comidaFin: "15:00",
            cierre: "18:00"
          },

          viernes: {
            activo: true,
            apertura: "09:00",
            comidaInicio: "14:00",
            comidaFin: "15:00",
            cierre: "18:00"
          },

          sabado: {
            activo: true,
            apertura: "09:00",
            comidaInicio: "",
            comidaFin: "",
            cierre: "14:00"
          },

          domingo: {
            activo: false,
            apertura: "09:00",
            comidaInicio: "",
            comidaFin: "",
            cierre: "14:00"
          }

        },

      whatsappEnabled:
        clinicData.whatsappEnabled || false,

      whatsappBusinessName:
        clinicData.whatsappBusinessName || "",

      whatsappNumber:
        clinicData.whatsappNumber || "",

      notifications:
        clinicData.notifications || {

          reminder24h: true,

          reminder2h: false,

          autoConfirm: true,

          cancelledAppointment: true,

          whatsappMessages: true

        },

      timeZone:
        clinicData.timeZone ||
        Intl.DateTimeFormat()
            .resolvedOptions()
            .timeZone,

    });

  }, [clinicData]);

  useEffect(() => {

    if (!clinicId)
      return;

    const unsubscribe = onSnapshot(

      doc(db, "clinics", clinicId),

      snapshot => {

        const data = snapshot.data();

        setWhatsappStatus(
          data?.whatsapp || null
        );

      }

    );

    return unsubscribe;

  }, [clinicId]);

  useEffect(() => {

    const cargarUsuario =
      async () => {

        if (
          !auth.currentUser
        ) return;

        try {

          const snap =
            await getDoc(

              doc(
                db,
                "users",
                auth.currentUser.uid

              )

            );

          if (
            !snap.exists()
          ) return;

          const data =
            snap.data();

          setUserSettings({

            firmaPersonalizada:
              data.firmaPersonalizada || "",

            useCustomSignature:
              data.useCustomSignature || false

          });

        } catch(err) {

          console.error(err);

        }

      };

    cargarUsuario();

  }, []);

  useEffect(() => {

    if (!clinicId)
      return;

    const cargarGoogleCalendar = async () => {

      try {

        const documento = await getDoc(
          doc(
            db,
            "clinics",
            clinicId,
            "integrationStatus",
            "googleCalendar"
          )
        );

        if (!documento.exists())
          return;

        const data = documento.data();

        setGoogleCalendarStatus({
          connected: data.connected || false,
          email: data.email || ""
        });

      } catch (err) {

        console.error(
          "Error cargando Google Calendar:",
          err
        );

      }

    };

    cargarGoogleCalendar();

  }, [clinicId]);

  useEffect(() => {

    if (!clinicId)
      return;

    const verificarVPS =
      async () => {

        try {

          const response =
            await protectedWhatsAppFetch(

              `https://wa.vexadent.com/health?clinicId=${clinicId}`

            );

          setVpsOnline(
            response.ok
          );

        } catch (err) {

          console.error(err);

          setVpsOnline(
            false
          );

        }

      };

    verificarVPS();

  }, [clinicId]);

  // =========================
  // HANDLE CHANGE
  // =========================

  const handleChange = e => {

    setForm(prev => ({

      ...prev,

      [e.target.name]:
        e.target.value

    }));

  };

  const handleHorarioChange = (
    dia,
    campo,
    valor
  ) => {

    setForm(prev => ({

      ...prev,

      horariosLaborales: {

        ...prev.horariosLaborales,

        [dia]: {

          ...prev.horariosLaborales[dia],

          [campo]: valor

        }

      }

    }));

  };

  const fileToBase64 = file => {

      return new Promise((resolve, reject) => {

          const reader = new FileReader();

          reader.readAsDataURL(file);

          reader.onload = () => resolve(reader.result);

          reader.onerror = error => reject(error);

      });

  };

  const subirLogo = async e => {

      try {

          const file = e.target.files[0];

          if (!file) return;

          // ==========================
          // SUBIR A FIREBASE STORAGE
          // ==========================

          const storageRef = ref(

              storage,

              `logos/${clinicId}`

          );

          await uploadBytes(

              storageRef,

              file

          );

          const url = await getDownloadURL(

              storageRef

          );

          // ==========================
          // CONVERTIR A BASE64
          // ==========================

          const logoBase64 = await fileToBase64(file);

          console.log("URL:", url);

          console.log("BASE64:", logoBase64?.substring(0, 80));

          // ==========================
          // ACTUALIZAR FORMULARIO
          // ==========================

          setForm(prev => ({

              ...prev,

              logoURL: url,

              logoBase64

          }));

      } catch(err) {

          console.error(err);

          alert("Error subiendo logo");

      }

  };

  // =========================
  // SAVE
  // =========================

  const guardar = async () => {

      try {

          setSaving(true);

          (can("settings","clinic")||can("settings","whatsappConfig")) && await updateDoc(

              doc(
                  db,
                  "clinics",
                  clinicId
              ),

              clinicSettingsPayload({

                  nombreClinica:
                      form.nombreClinica,

                  telefono:
                      form.telefono,

                  email:
                      form.email,

                  RFC:
                      form.RFC,

                  direccion:
                      form.direccion,

                  logoURL:
                      form.logoURL,

                  // NUEVO
                  logoBase64:
                    form.logoBase64 ||
                    clinicData.logoBase64 ||
                    null,

                  horaApertura:
                      form.horaApertura,

                  horaCierre:
                      form.horaCierre,

                  intervaloAgenda:
                      form.intervaloAgenda,

                  defaultAppointmentDuration:
                      form.defaultAppointmentDuration,

                  horariosLaborales:
                      form.horariosLaborales,

                  whatsappEnabled:
                      form.whatsappEnabled,

                  whatsappBusinessName:
                      form.whatsappBusinessName,

                  whatsappNumber:
                      form.whatsappNumber,

                  notifications:
                      form.notifications,

                  timeZone:
                      form.timeZone

              },can)

          );

          await updateDoc(

              doc(
                  db,
                  "users",
                  auth.currentUser.uid
              ),

              {

                  firmaPersonalizada:
                      userSettings
                          .firmaPersonalizada,

                  useCustomSignature:
                      userSettings
                          .useCustomSignature

              }

          );

          notify({
            source: "vexa-alert",
            tone: "success",
            title: "Configuración guardada",
            message: "Los cambios se guardaron correctamente."
          });

      } catch(err) {

          console.error(err);

          notify({
            source: "vexa-alert",
            tone: "error",
            title: "No se pudo guardar la configuración",
            message: err.message || "Intenta de nuevo en unos momentos."
          });

      } finally {

          setSaving(false);

      }

  };

  const conectarWhatsApp = async () => {

  try {

    const response = await protectedWhatsAppFetch(
      "https://wa.vexadent.com/create-session",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          clinicId
        })
      }
    );

    console.log(
      "STATUS:",
      response.status
    );

    const data =
      await response.json();

    console.log(
      "DATA:",
      data
    );

    if (response.ok) {

        notify({

            type: "success",

            title:
                "Conectando WhatsApp",

            message:
                "La solicitud se envió correctamente. La generación del código QR puede tardar entre 10 y 30 segundos.",

        });

    } else {

        notify({

            type: "error",

            title:
                "Error",

            message:
                `No fue posible iniciar la sesión de WhatsApp (${response.status}).`

        });

    }

  } catch (err) {

    console.error(
      "ERROR:",
      err
    );

    alert(
      err.message
    );

  }

};

  const desconectarWhatsApp = async () => {

    try {

      const ok = await requestVexaConfirm(
        "¿Cerrar sesión de WhatsApp?"
      );

      if (!ok) return;

      const response = await protectedWhatsAppFetch(
        "https://wa.vexadent.com/disconnect-session",
        {
          method:"POST",
          headers:{
            "Content-Type":"application/json"
          },
          body: JSON.stringify({
            clinicId
          })
        }
      );

      const data =
        await response.json();

      if(data.success){

        alert(
          "WhatsApp desconectado"
        );

      } else {

        alert(
          data.error ||
          "Error"
        );

      }

    } catch(err){

      console.error(err);

      alert(
        "Error desconectando"
      );

    }

  };

  const importarEventosGoogle = async () => {

    try {

      setImportandoGoogle(true);

      setResultadoImportacion(null);

      const data = await importGoogleCalendar(clinicId);

      if(data.success){

        setResultadoImportacion(data);

        notify({

          type:"success",

          title:"Google Calendar",

          message:"Importación finalizada."

        });

      }else{

        notify({

          type:"error",

          title:"Google Calendar",

          message:data.message

        });

      }

    }catch(err){

      console.error(err);

      notify({

        type:"error",

        title:"Google Calendar",

        message:"Error al importar eventos."

      });

    }finally{

      setImportandoGoogle(false);

    }

  };

  const desconectarGoogleCalendar = async () => {

    const ok = await requestVexaConfirm(

      "¿Deseas desconectar Google Calendar?"

    );

    if (!ok) return;

    try {

      await disconnectGoogleCalendar(clinicId);

      setGoogleCalendarStatus({

        connected: false,

        email: ""

      });

      notify({

        type: "success",

        title: "Google Calendar",

        message: "Google Calendar fue desconectado."

      });

    } catch (err) {

      console.error(err);

      notify({

        type: "error",

        title: "Google Calendar",

        message: "No fue posible desconectar Google Calendar."

      });

    }

  };

  const cambiarPassword = async () => {

    try {

      if (
        !passwordRegex.test(
          newPassword
        )
      ) {

        alert(
          "La contraseña debe contener mayúscula, minúscula, número y caracter especial."
        );

        return;
      }

      if (
        newPassword !==
        confirmPassword
      ) {

        alert(
          "Las contraseñas no coinciden."
        );

        return;
      }

      const user =
        auth.currentUser;

      const credential =
        EmailAuthProvider.credential(
          user.email,
          currentPassword
        );

      await reauthenticateWithCredential(
        user,
        credential
      );

      await updatePassword(
        user,
        newPassword
      );

      alert(
        "Contraseña actualizada correctamente."
      );

      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");

      setShowPasswordModal(
        false
      );

    } catch (err) {

      console.error(err);

      if (
        err.code ===
        "auth/wrong-password"
      ) {

        alert(
          "La contraseña actual es incorrecta."
        );

      } else {

        alert(
          err.message
        );

      }
    }

  };

  const buscarCP =
    async (cp) => {

      if (
        !cp ||
        cp.length !== 5
      ) return;

      try {

        const res =
          await fetch(
            `https://api.zippopotam.us/mx/${cp}`
          );

        if (!res.ok)
          return;

        const data =
          await res.json();

        const places =
          data.places || [];

        const listaColonias =
          places.map(
            p => p["place name"]
          );

        setColonias(
          listaColonias
        );

        setForm(prev => ({

          ...prev,

          direccion: {

            ...prev.direccion,

            colonia:
              prev.direccion
                .colonia ||

              listaColonias[0] ||

              "",

            estado:
              places[0]?.state ||
              ""

          }

        }));

      } catch (err) {

        console.error(
          "Error CP:",
          err
        );

      }

  };

  useEffect(() => {

    if (

      form.direccion
        .codigoPostal
        .length === 5

    ) {

      buscarCP(

        form.direccion
          .codigoPostal

      );

    }

  }, [

    form.direccion
      .codigoPostal

  ]);

  // =========================
  // UI
  // =========================

  const inputStyle = {

    padding:"12px 14px",

    borderRadius:12,

    border:"1px solid #d1d5db",

    width:"100%",

    fontSize:14,

    outline:"none"

  };

  const [showPasswordModal, setShowPasswordModal] =
    useState(false);

  const [currentPassword, setCurrentPassword] =
    useState("");

  const [newPassword, setNewPassword] =
    useState("");

  const [confirmPassword, setConfirmPassword] =
    useState("");

  const [showCurrentPassword, setShowCurrentPassword] =
    useState(false);

  const [showNewPassword, setShowNewPassword] =
    useState(false);

  const [showConfirmPassword, setShowConfirmPassword] =
    useState(false);

  const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

  const [
    settingsTab,
    setSettingsTab
  ] = useState(
    "control"
  );

  const [settingsQuery, setSettingsQuery] = useState("");

  const [
    showMobileAppModal,
    setShowMobileAppModal
  ] = useState(false);

  const [
    userSettings,
    setUserSettings
  ] = useState({

    firmaPersonalizada:"",

    useCustomSignature:false

  });

  const [historiaClinicaSave, setHistoriaClinicaSave] =
    useState(null);

  const [historiaClinicaSaving, setHistoriaClinicaSaving] =
    useState(false);

  const filteredSettingsGroups = SETTINGS_NAV_GROUPS
    .map(group => ({
      ...group,
      items: group.items.filter(item => {
        const search = settingsQuery.trim().toLowerCase();
        if (!search) return true;
        return [item.label, item.description, group.label]
          .join(" ")
          .toLowerCase()
          .includes(search);
      })
    }))
    .filter(group => group.items.length > 0);

  const activeSetting = SETTINGS_ITEMS.find(
    item => item.key === settingsTab
  ) || SETTINGS_ITEMS[0];

  const activeClinicDays = Object.values(
    form.horariosLaborales || {}
  ).filter(day => day?.activo).length;

  const openSettings = key => {
    setSettingsTab(key);
    setSettingsQuery("");
  };

  const renderSettingsOverview = () => (
    <div className="vd-settings-overview">
      <section className="vd-settings-overview-hero">
        <div>
          <p className="vd-settings-kicker">Centro de control</p>
          <h2>Todo tu consultorio, bajo control.</h2>
          <p>
            Configura VexaDent a la medida de tu equipo: agenda, expediente,
            comunicación, integraciones y seguridad en un solo lugar.
          </p>
        </div>
        <div className="vd-settings-health-badge">
          <span className="vd-settings-health-dot" />
          <div>
            <strong>Tu espacio está activo</strong>
            <small>Los cambios se guardan en tu consultorio</small>
          </div>
        </div>
      </section>

      <section className="vd-settings-status-grid" aria-label="Estado de configuración">
        <div className="vd-settings-status-card">
          <div className="vd-settings-status-icon is-blue"><Building2 size={18} /></div>
          <span>Consultorio</span>
          <strong>{form.nombreClinica || "Aún sin nombre"}</strong>
          <small>{form.email || "Agrega un correo de contacto"}</small>
        </div>
        <div className="vd-settings-status-card">
          <div className="vd-settings-status-icon is-purple"><CalendarDays size={18} /></div>
          <span>Agenda</span>
          <strong>{activeClinicDays} días activos</strong>
          <small>Intervalos de {form.intervaloAgenda || "15"} minutos</small>
        </div>
        <div className="vd-settings-status-card">
          <div className="vd-settings-status-icon is-green"><MessageCircle size={18} /></div>
          <span>Comunicación</span>
          <strong>{form.whatsappEnabled ? "WhatsApp conectado" : "Revisar WhatsApp"}</strong>
          <small>{form.notifications?.reminder24h ? "Recordatorio 24 h activo" : "Activa tus recordatorios"}</small>
        </div>
        <div className="vd-settings-status-card">
          <div className="vd-settings-status-icon is-amber"><ShieldCheck size={18} /></div>
          <span>Seguridad</span>
          <strong>Cuenta protegida</strong>
          <small>Administra accesos desde Cuenta y seguridad</small>
        </div>
      </section>

      <section className="vd-settings-overview-section">
        <div className="vd-settings-section-heading">
          <div>
            <p className="vd-settings-kicker">Configuración completa</p>
            <h3>Elige qué quieres ajustar</h3>
          </div>
          <span>{SETTINGS_ITEMS.length - 1} áreas disponibles</span>
        </div>
        <div className="vd-settings-overview-grid">
          {SETTINGS_ITEMS.filter(item => item.key !== "overview").map(item => {
            const Icon = item.icon;
            return (
              <button
                key={item.key}
                type="button"
                className="vd-settings-overview-card"
                onClick={() => openSettings(item.key)}
              >
                <span className="vd-settings-card-icon"><Icon size={19} /></span>
                <span className="vd-settings-card-copy">
                  <strong>{item.label}</strong>
                  <small>{item.description}</small>
                </span>
                <ChevronRight size={18} />
              </button>
            );
          })}
        </div>
      </section>

      <section className="vd-settings-setup-card">
        <div className="vd-settings-setup-icon"><Check size={20} /></div>
        <div>
          <strong>Una configuración clara para trabajar mejor</strong>
          <p>
            Empieza por Consultorio y marca, Agenda y citas y Notificaciones.
            Después conecta WhatsApp para que VexaDent haga el seguimiento por ti.
          </p>
        </div>
        <button type="button" onClick={() => openSettings("general")}>
          Empezar configuración <ChevronRight size={16} />
        </button>
      </section>
    </div>
  );

  return (

    <>

      <div className="vd-module-page vd-settings-page">
        <div className="vd-settings-layout">
          <aside className="vd-settings-sidebar" aria-label="Secciones de configuración">
            <div className="vd-settings-sidebar-brand">
              <div className="vd-settings-sidebar-brand-icon"><Settings2 size={18} /></div>
              <div>
                <strong>Ajustes</strong>
                <small>Centro de control</small>
              </div>
            </div>

            <label className="vd-settings-search">
              <Search size={16} />
              <input
                value={settingsQuery}
                onChange={event => setSettingsQuery(event.target.value)}
                placeholder="Buscar un ajuste..."
                aria-label="Buscar un ajuste"
              />
            </label>

            <nav className="vd-settings-nav">
              {filteredSettingsGroups.map(group => (
                <div key={group.label} className="vd-settings-nav-group">
                  <p>{group.label}</p>
                  {group.items.map(item => {
                    const Icon = item.icon;
                    const isActive = settingsTab === item.key;
                    return (
                      <button
                        key={item.key}
                        type="button"
                        className={`vd-settings-nav-item${isActive ? " is-active" : ""}`}
                        onClick={() => openSettings(item.key)}
                      >
                        <span className="vd-settings-nav-icon"><Icon size={16} /></span>
                        <span>{item.label}</span>
                        {isActive && <span className="vd-settings-nav-current" />}
                      </button>
                    );
                  })}
                </div>
              ))}
              {filteredSettingsGroups.length === 0 && (
                <div className="vd-settings-empty-search">
                  <Search size={18} />
                  <span>No encontramos ese ajuste.</span>
                </div>
              )}
            </nav>

            <div className="vd-settings-sidebar-tip">
              <div><Check size={14} /></div>
              <span>Los cambios se aplican a todo tu consultorio.</span>
            </div>
          </aside>

          <main className="vd-settings-workspace">
            <div className="vd-settings-workspace-header">
              <div className="vd-page-heading">
                <div className="vd-page-heading-icon"><Settings2 size={23} /></div>
                <div>
                  <p className="vd-page-heading-eyebrow">Personaliza VexaDent</p>
                  <h1>{activeSetting.label}</h1>
                  <p className="vd-page-heading-subtitle">{activeSetting.description}</p>
                </div>
              </div>
              <div className="vd-settings-breadcrumb">
                <span>Ajustes</span><ChevronRight size={14} /><strong>{activeSetting.label}</strong>
              </div>
            </div>
      {/* CARD */}

      {
        settingsTab === "overview" && renderSettingsOverview()
      }

      {
        settingsTab === "control" && <AdvancedClinicSettings />
      }

      {
        settingsTab ===
        "general" && (

        <div style={{

          background:"#fff",

          padding:24,

          borderRadius:24,

          display:"flex",

          flexDirection:"column",

          gap:20,

          maxWidth:1000

      }}>

        {/* LOGO */}

        <div style={{
          display:"flex",
          gap:18,
          alignItems:"center"
        }}>

          {form.logoURL ? (

            <img
              src={form.logoURL}
              alt="logo"
              style={{
                width:80,
                height:80,
                borderRadius:20,
                objectFit:"cover"
              }}
            />

          ) : (

            <div style={{
              width:80,
              height:80,
              borderRadius:20,
              background:"#2563eb",
              color:"#fff",
              display:"flex",
              alignItems:"center",
              justifyContent:"center",
              fontSize:32,
              fontWeight:800
            }}>

              V

            </div>

          )}

          <div style={{
            flex:1
          }}>

            <div style={{
              fontWeight:700,
              marginBottom:8
            }}>

              URL del logo
            </div>

            <input
                type="file"
                accept="image/*"
                onChange={subirLogo}
            />

          </div>

        </div>

        {/* GRID */}

        <div style={{

          display:"grid",

          gridTemplateColumns:
            "1fr 1fr",

          gap:16
        }}>

          <div>

            <div style={{
              marginBottom:8,
              fontWeight:600
            }}>

              Nombre clínica
            </div>

            <input disabled={!can("settings","clinic")}
              name="nombreClinica"
              value={form.nombreClinica}
              onChange={handleChange}
              style={inputStyle}
            />

          </div>

          <div>

            <div style={{
              marginBottom:8,
              fontWeight:600
            }}>

              Teléfono
            </div>

            <input disabled={!can("settings","clinic")}
              name="telefono"
              value={form.telefono}
              onChange={handleChange}
              style={inputStyle}
            />

          </div>

          <div>

            <div style={{
              marginBottom:8,
              fontWeight:600
            }}>

              Correo
            </div>

            <input disabled={!can("settings","clinic")}
              name="email"
              value={form.email}
              onChange={handleChange}
              style={inputStyle}
            />

          </div>

          <div>

            <div style={{
              marginBottom:8,
              fontWeight:600
            }}>

              RFC
            </div>

            <input disabled={!can("settings","clinic")}
              name="RFC"
              value={form.RFC}
              onChange={handleChange}
              style={inputStyle}
            />

          </div>

          <div
            style={{
              gridColumn:"1 / -1"
            }}
          >

            <div
              style={{
                marginBottom:8,
                fontWeight:600
              }}
            >
              Dirección
            </div>

            <div
              style={{
                display:"grid",
                gridTemplateColumns:
                  "1fr 160px 160px",
                gap:12
              }}
            >

              <input
                placeholder="Calle"
                value={form.direccion.calle}
                onChange={e =>

                  setForm(prev => ({

                    ...prev,

                    direccion:{

                      ...prev.direccion,

                      calle:
                        e.target.value

                    }

                  }))

                }
                style={inputStyle}
              />

              <input
                placeholder="No. Exterior"
                value={
                  form.direccion
                    .numeroExterior
                }
                onChange={e =>

                  setForm(prev => ({

                    ...prev,

                    direccion:{

                      ...prev.direccion,

                      numeroExterior:
                        e.target.value

                    }

                  }))

                }
                style={inputStyle}
              />

              <input
                placeholder="No. Interior"
                value={
                  form.direccion
                    .numeroInterior
                }
                onChange={e =>

                  setForm(prev => ({

                    ...prev,

                    direccion:{

                      ...prev.direccion,

                      numeroInterior:
                        e.target.value

                    }

                  }))

                }
                style={inputStyle}
              />

            </div>

            <div
              style={{
                display:"grid",
                gridTemplateColumns:
                  "180px 1fr 1fr",
                gap:12,
                marginTop:12
              }}
            >

              <input
                placeholder="Código Postal"
                value={
                  form.direccion
                    .codigoPostal
                }
                onChange={e =>

                  setForm(prev => ({

                    ...prev,

                    direccion:{

                      ...prev.direccion,

                      codigoPostal:
                        e.target.value

                    }

                  }))

                }
                style={inputStyle}
              />

              <select

                value={
                  form.direccion
                    .colonia
                }

                onChange={e =>

                  setForm(prev => ({

                    ...prev,

                    direccion: {

                      ...prev.direccion,

                      colonia:
                        e.target.value

                    }

                  }))

                }

                style={inputStyle}

              >

                {

                  colonias.map(
                    colonia => (

                      <option
                        key={colonia}
                        value={colonia}
                      >

                        {colonia}

                      </option>

                    )
                  )

                }

              </select>

            </div>

            <div
              style={{
                display:"grid",
                gridTemplateColumns:
                  "1fr 1fr",
                gap:12,
                marginTop:12
              }}
            >

              <input

                placeholder="Ciudad"

                value={
                  form.direccion
                    .ciudad
                }

                onChange={e =>

                  setForm(prev => ({

                    ...prev,

                    direccion:{

                      ...prev.direccion,

                      ciudad:
                        e.target.value

                    }

                  }))

                }

                style={inputStyle}

              />

              <input
                placeholder="Estado"
                value={
                  form.direccion
                    .estado
                }
                onChange={e =>

                  setForm(prev => ({

                    ...prev,

                    direccion:{

                      ...prev.direccion,

                      estado:
                        e.target.value

                    }

                  }))

                }
                style={inputStyle}
              />

            </div>

          </div>

          <div>

            <div
              style={{
                marginBottom:8,
                fontWeight:600
              }}
            >

              Zona horaria de respaldo

            </div>

            <input disabled={!can("settings","clinic")}
              name="timeZone"
              value={form.timeZone}
              onChange={handleChange}
              style={inputStyle}
            />

            <small style={{display:"block",marginTop:6,color:"#71809a"}}>
              Las citas nuevas detectan automáticamente la zona horaria de cada dispositivo. Este valor conserva compatibilidad con citas antiguas.
            </small>

          </div>

          <div>

            <div
              style={{
                marginBottom: 8,
                fontWeight: 600
              }}
            >
              Intervalo de agenda
            </div>

            <select disabled={!can("settings","clinic")}
              name="intervaloAgenda"
              value={form.intervaloAgenda}
              onChange={handleChange}
              style={inputStyle}
            >

              <option value="15">
                15 minutos
              </option>

              <option value="30">
                30 minutos
              </option>

              <option value="60">
                60 minutos
              </option>

            </select>

          </div>

          <div>

            <div
              style={{
                marginBottom:8,
                fontWeight:600
              }}
            >
              Duración predeterminada
            </div>

            <select disabled={!can("settings","clinic")}

              value={
                form
                  .defaultAppointmentDuration
              }

              onChange={e =>

                setForm(prev => ({

                  ...prev,

                  defaultAppointmentDuration:
                    e.target.value

                }))

              }

              style={inputStyle}

            >

              <option value="15">
                15 minutos
              </option>

              <option value="30">
                30 minutos
              </option>

              <option value="45">
                45 minutos
              </option>

              <option value="60">
                60 minutos
              </option>

              <option value="90">
                90 minutos
              </option>

              <option value="120">
                120 minutos
              </option>

            </select>

          </div>

          </div>

        </div>

        )}

        {
          settingsTab ===
          "horarios" && (

            <div
              style={{
                background: "#fff",
                padding: 24,
                borderRadius: 24,
                maxWidth: 1000
              }}
            >

              <div
                style={{
                  marginBottom: 24,
                  fontSize: 20,
                  fontWeight: 700
                }}
              >
                Horarios laborales
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "180px 140px 140px 140px 140px",
                  gap: 12,
                  alignItems: "center"
                }}
              >

                <div />

                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#64748b"
                  }}
                >
                  Apertura
                </div>

                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#64748b"
                  }}
                >
                  Comida inicio
                </div>

                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#64748b"
                  }}
                >
                  Comida fin
                </div>

                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#64748b"
                  }}
                >
                  Cierre
                </div>

                {[
                  "lunes",
                  "martes",
                  "miercoles",
                  "jueves",
                  "viernes",
                  "sabado",
                  "domingo"
                ].map((dia) => {

                  const horario =
                    form.horariosLaborales?.[dia];

                  if (!horario)
                    return null;

                  return (

                    <>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          opacity:
                            horario.activo
                              ? 1
                              : 0.45,
                          fontWeight: 600
                        }}
                      >

                        <input
                          type="checkbox"
                          checked={
                            horario.activo
                          }
                          onChange={e =>
                            handleHorarioChange(
                              dia,
                              "activo",
                              e.target.checked
                            )
                          }
                        />

                        {{
                          lunes: "Lunes",
                          martes: "Martes",
                          miercoles:
                            "Miércoles",
                          jueves: "Jueves",
                          viernes:
                            "Viernes",
                          sabado: "Sábado",
                          domingo:
                            "Domingo"
                        }[dia]}

                      </div>

                      <input
                        type="time"
                        value={
                          horario.apertura
                        }
                        onChange={e =>
                          handleHorarioChange(
                            dia,
                            "apertura",
                            e.target.value
                          )
                        }
                        disabled={
                          !horario.activo
                        }
                        style={inputStyle}
                      />

                      <input
                        type="time"
                        value={
                          horario.comidaInicio || ""
                        }
                        onChange={e =>
                          handleHorarioChange(
                            dia,
                            "comidaInicio",
                            e.target.value
                          )
                        }
                        disabled={
                          !horario.activo
                        }
                        style={inputStyle}
                      />

                      <input
                        type="time"
                        value={
                          horario.comidaFin || ""
                        }
                        onChange={e =>
                          handleHorarioChange(
                            dia,
                            "comidaFin",
                            e.target.value
                          )
                        }
                        disabled={
                          !horario.activo
                        }
                        style={inputStyle}
                      />

                      <input
                        type="time"
                        value={
                          horario.cierre
                        }
                        onChange={e =>
                          handleHorarioChange(
                            dia,
                            "cierre",
                            e.target.value
                          )
                        }
                        disabled={
                          !horario.activo
                        }
                        style={inputStyle}
                      />

                    </>

                  );

                })}

              </div>

            </div>

        )}

        {settingsTab === "procedures" && <ProceduresSettings />}

        {settingsTab === "medicamentos" && <MedicationsSettings />}

        {settingsTab === "historiaClinica" && (
          <HistoriaClinicaSettings
            onRegisterSave={setHistoriaClinicaSave}
            onSavingChange={setHistoriaClinicaSaving}
          />
        )}

        {settingsTab === "consentimientos" && <ConsentimientosSettings />}

        {
          settingsTab === "comunicacion" && (
            <ComunicacionCampanasPanel
              saveHandlerRef={comunicacionSaveRef}
            />
          )
        }

        {
          settingsTab ===
          "integraciones" && (
            <ConnectionsSettings />
          )
        }

        {
          settingsTab ===
          "__legacyIntegraciones" && (

            <div
              className="vd-settings-integrations-panel"
              style={{
                display:"grid",
                gridTemplateColumns:
                  "repeat(auto-fit,minmax(520px,1fr))",
                gap:28,
                maxWidth:1200,
                margin:"0 auto",
                alignItems:"start"
              }}
            >

              <div
                style={{
                  background:"#fff",
                  border:"1px solid #e2e8f0",
                  borderRadius:24,
                  padding:30,
                  boxShadow:"0 10px 30px rgba(15,23,42,.05)",
                  display:"flex",
                  flexDirection:"column",
                  height:"100%"
                }}
              >

                <div
                  style={{
                  display:"flex",
                  alignItems:"center",
                  gap:20,
                  marginBottom:24
                }}
                >

                  <div
                    style={{
                      width:56,
                      height:56,
                      borderRadius:18,
                      background:"#dcfce7",
                      display:"flex",
                      justifyContent:"center",
                      alignItems:"center",
                      flexShrink:0
                    }}
                  >

                    <MessageCircle
                      size={28}
                      color="#16a34a"
                    />

                  </div>

                  <div>

                    <div
                      style={{
                        fontSize:23,
                        fontWeight:700,
                        marginBottom:4,
                        color:"#0f172a"
                      }}
                    >

                      WhatsApp

                    </div>

                    <div
                      style={{
                        color:"#64748b",
                        fontSize:15,
                        lineHeight:1.6,
                        maxWidth:420
                      }}
                    >

                      Envía mensajes automáticos y administra conversaciones con tus pacientes.

                    </div>

                  </div>

              </div>

              <div
                style={{
                  marginBottom:24,
                  padding:20,
                  borderRadius:18,
                  background:"#f8fafc",
                  border:"1px solid #e2e8f0",
                  flex:1,
                  display:"flex",
                  flexDirection:"column"
                }}
              >

                {!whatsappStatus && (

                  <div
                    style={{
                      color:"#64748b",
                      textAlign:"center"
                    }}
                  >
                    Sin información disponible.
                  </div>

                )}

                {

                  whatsappStatus?.status === "waiting_qr" && (

                    <div
                      style={{
                        display:"flex",
                        flexDirection:"column",
                        alignItems:"center",
                        maxWidth:420,
                        margin:"0 auto"
                      }}
                    >

                      <div
                        style={{
                          width:64,
                          height:64,
                          borderRadius:20,
                          background:"#fef3c7",
                          display:"flex",
                          justifyContent:"center",
                          alignItems:"center",
                          marginBottom:20
                        }}
                      >

                        <QrCode
                          size={30}
                          color="#d97706"
                        />

                      </div>

                      <div
                        style={{
                          fontWeight:700,
                          fontSize:20,
                          color:"#0f172a",
                          marginBottom:8
                        }}
                      >

                        Escanea el código QR

                      </div>

                      <div
                        style={{
                          color:"#64748b",
                          textAlign:"center",
                          lineHeight:1.6,
                          marginBottom:24,
                          maxWidth:340
                        }}
                      >

                        Abre WhatsApp Business en tu teléfono y escanea este código para conectar el consultorio.

                      </div>

                      {

                        whatsappStatus.qr && (

                          <div
                            style={{
                              background:"#ffffff",
                              border:"1px solid #e2e8f0",
                              borderRadius:20,
                              padding:20,
                              boxShadow:"0 8px 20px rgba(15,23,42,.06)"
                            }}
                          >

                            <img
                              src={whatsappStatus.qr}
                              alt="QR WhatsApp"
                              style={{
                                width:260,
                                display:"block"
                              }}
                            />

                          </div>

                        )

                      }

                    </div>

                  )

                }

                {

                  whatsappStatus && (

                    <div
                      style={{
                        display:"flex",
                        justifyContent:"space-between",
                        alignItems:"flex-start",
                        gap:32
                      }}
                    >

                      {/* INFORMACIÓN */}

                      <div
                        style={{
                          flex:1,
                          minWidth:0
                        }}
                      >

                        <div
                          style={{
                            display:"flex",
                            alignItems:"center",
                            gap:16,
                            padding:18,
                            background:"#f8fafc",
                            border:"1px solid #e2e8f0",
                            borderRadius:16
                          }}
                        >

                          {

                            whatsappStatus.connected

                              ? (

                                <CheckCircle2
                                  size={22}
                                  color="#16a34a"
                                />

                              )

                              : (

                                <CircleOff
                                  size={22}
                                  color="#dc2626"
                                />

                              )

                          }

                          <div>

                            <div
                              style={{
                                fontWeight:700,
                                color:"#0f172a"
                              }}
                            >

                              {

                                whatsappStatus.connected
                                  ? "WhatsApp conectado"
                                  : "WhatsApp desconectado"

                              }

                            </div>

                            <div
                              style={{
                                color:"#64748b",
                                fontSize:14,
                                marginTop:4
                              }}
                            >

                              {whatsappStatus.phoneNumber || "Sin número"}

                            </div>

                          </div>

                        </div>

                      </div>

                      {/* BOTONES */}

                      <div
                        style={{
                          width:260,
                          display:"flex",
                          flexDirection:"column",
                          gap:14,
                          flexShrink:0,
                          alignSelf:"flex-start"
                        }}
                      >

                        <button

                          onClick={conectarWhatsApp}

                          style={{
                            height:52,
                            border:"none",
                            borderRadius:14,
                            background:
                              whatsappStatus.connected
                                ? "#2563eb"
                                : "#16a34a",
                            color:"#fff",
                            fontWeight:700,
                            fontSize:15,
                            cursor:"pointer",
                            display:"flex",
                            justifyContent:"center",
                            alignItems:"center",
                            gap:10,
                            transition:".2s",
                            boxShadow:"0 2px 8px rgba(37,99,235,.15)"
                          }}

                        >

                          <Link2 size={18} />

                          {

                            whatsappStatus.connected
                              ? "Reconectar WhatsApp"
                              : "Conectar WhatsApp"

                          }

                        </button>

                        <button

                          onClick={desconectarWhatsApp}

                          style={{
                            height:52,
                            border:"none",
                            borderRadius:14,
                            background:"#dc2626",
                            color:"#fff",
                            fontWeight:700,
                            fontSize:15,
                            cursor:"pointer",
                            display:"flex",
                            justifyContent:"center",
                            alignItems:"center",
                            gap:10,
                            transition:".2s",
                            boxShadow:"0 2px 8px rgba(220,38,38,.15)"
                          }}

                        >

                          <Unplug size={18} />

                          Desconectar WhatsApp

                        </button>

                      </div>

                    </div>

                  )

                }

              </div>

              <div
                style={{
                  display:"grid",
                  gridTemplateColumns:"1fr 1fr",
                  gap:22,
                  marginTop:32
                }}
              >

                <div>

                  <div
                    style={{
                      marginBottom:8,
                      fontWeight:600
                    }}
                  >
                    Nombre comercial
                  </div>

                  <input disabled={!can("settings","whatsappConfig")}
                    name="whatsappBusinessName"
                    value={form.whatsappBusinessName}
                    onChange={handleChange}
                    style={inputStyle}
                  />

                </div>

                <div>

                  <div
                    style={{
                      marginBottom:8,
                      fontWeight:600
                    }}
                  >
                    Número WhatsApp
                  </div>

                  <input disabled={!can("settings","whatsappConfig")}
                    name="whatsappNumber"
                    value={form.whatsappNumber}
                    onChange={handleChange}
                    style={inputStyle}
                  />

                </div>

              </div>

              <label
                style={{
                  display:"flex",
                  alignItems:"center",
                  gap:12,
                  marginTop:28,
                  fontWeight:600,
                  color:"#334155"
                }}
              >

                <input disabled={!can("settings","whatsappConfig")}
                  type="checkbox"
                  checked={form.whatsappEnabled}
                  onChange={e =>
                    setForm(prev => ({
                      ...prev,
                      whatsappEnabled:e.target.checked
                    }))
                  }
                />

                Activar WhatsApp

              </label>

              </div>

              <div
                style={{
                  background:"#ffffff",
                  border:"1px solid #e5e7eb",
                  borderRadius:24,
                  padding:28,
                  boxShadow:"0 4px 18px rgba(0,0,0,.04)",
                  display:"flex",
                  flexDirection:"column",
                  height:"100%"
                }}
              >

                {/* ENCABEZADO */}

                <div
                  style={{
                    display:"flex",
                    alignItems:"center",
                    gap:18,
                    marginBottom:28
                  }}
                >

                  <div
                    style={{
                      width:56,
                      height:56,
                      borderRadius:18,
                      background:"#dbeafe",
                      display:"flex",
                      justifyContent:"center",
                      alignItems:"center"
                    }}
                  >

                    <CalendarDays
                      size={28}
                      color="#2563eb"
                    />

                  </div>

                  <div>

                    <div
                      style={{
                        fontSize:22,
                        fontWeight:700
                      }}
                    >
                      Google Calendar
                    </div>

                    <div
                      style={{
                        color:"#64748b",
                        marginTop:4
                      }}
                    >
                      Sincroniza automáticamente las citas entre Google Calendar y VexaDent.
                    </div>

                  </div>

                </div>

                {/* CONTENIDO */}

                <div
                  style={{
                    display:"flex",
                    justifyContent:"space-between",
                    alignItems:"flex-start",
                    gap:32,
                    flexWrap:"wrap"
                  }}
                >

                  {/* LADO IZQUIERDO */}

                  <div
                    style={{
                      flex:1,
                      minWidth:320
                    }}
                  >

                    <div
                      style={{
                        display:"flex",
                        alignItems:"center",
                        gap:16,
                        padding:18,
                        background:"#f8fafc",
                        border:"1px solid #e2e8f0",
                        borderRadius:16,
                        marginBottom:24
                      }}
                    >

                      {

                        googleCalendarStatus.connected

                          ? (

                            <CheckCircle2
                              size={22}
                              color="#16a34a"
                            />

                          )

                          : (

                            <CircleOff
                              size={22}
                              color="#dc2626"
                            />

                          )

                      }

                      <div>

                        <div
                          style={{
                            fontWeight:700,
                            color:"#0f172a"
                          }}
                        >

                          Google Calendar

                        </div>

                        <div
                          style={{
                            fontSize:14,
                            color:
                              googleCalendarStatus.connected
                                ? "#16a34a"
                                : "#dc2626"
                          }}
                        >

                          {

                            googleCalendarStatus.connected

                              ? "Conectado correctamente"

                              : "No conectado"

                          }

                        </div>

                      </div>

                    </div>

                    {

                      resultadoImportacion && (

                        <div
                          style={{
                            display:"grid",
                            gridTemplateColumns:"repeat(2,1fr)",
                            gap:16,
                            marginTop:6
                          }}
                        >

                          <div
                            style={{
                              background: "#f0fdf4",
                              border: "1px solid #bbf7d0",
                              borderRadius: 14,
                              padding: 16,
                              textAlign: "center"
                            }}
                          >

                            <Download
                              size={22}
                              color="#16a34a"
                              style={{ marginBottom: 8 }}
                            />

                            <div
                              style={{
                                fontSize: 26,
                                fontWeight: 700,
                                color: "#16a34a"
                              }}
                            >
                              {resultadoImportacion.imported}
                            </div>

                            <div
                              style={{
                                fontSize: 13,
                                color: "#166534"
                              }}
                            >
                              Importados
                            </div>

                          </div>

                          <div
                            style={{
                              background: "#f8fafc",
                              border: "1px solid #cbd5e1",
                              borderRadius: 14,
                              padding: 16,
                              textAlign: "center"
                            }}
                          >

                            <CircleOff
                              size={22}
                              color="#64748b"
                              style={{ marginBottom: 8 }}
                            />

                            <div
                              style={{
                                fontSize: 26,
                                fontWeight: 700
                              }}
                            >
                              {resultadoImportacion.skipped}
                            </div>

                            <div
                              style={{
                                fontSize: 13,
                                color: "#64748b"
                              }}
                            >
                              Omitidos
                            </div>

                          </div>

                          <div
                            style={{
                              background: "#eff6ff",
                              border: "1px solid #bfdbfe",
                              borderRadius: 14,
                              padding: 16,
                              textAlign: "center"
                            }}
                          >

                            <CalendarDays
                              size={22}
                              color="#2563eb"
                              style={{ marginBottom: 8 }}
                            />

                            <div
                              style={{
                                fontSize: 26,
                                fontWeight: 700,
                                color: "#2563eb"
                              }}
                            >
                              {resultadoImportacion.total}
                            </div>

                            <div
                              style={{
                                fontSize: 13,
                                color: "#1d4ed8"
                              }}
                            >
                              Encontrados
                            </div>

                          </div>

                          <div
                            style={{
                              background: "#fef2f2",
                              border: "1px solid #fecaca",
                              borderRadius: 14,
                              padding: 16,
                              textAlign: "center"
                            }}
                          >

                            <AlertTriangle
                              size={22}
                              color="#dc2626"
                              style={{ marginBottom: 8 }}
                            />

                            <div
                              style={{
                                fontSize: 26,
                                fontWeight: 700,
                                color: "#dc2626"
                              }}
                            >
                              {resultadoImportacion.errors}
                            </div>

                            <div
                              style={{
                                fontSize: 13,
                                color: "#b91c1c"
                              }}
                            >
                              Errores
                            </div>

                          </div>

                        </div>

                      )

                    }

                  </div>

                  {/* BOTONES */}

                  <div
                    style={{
                      display:"flex",
                      flexDirection:"column",
                      gap:14,
                      width:260,
                      minWidth:260,
                      flexShrink:0
                    }}
                  >

                    {

                      !googleCalendarStatus.connected && (

                        <button

                          onClick={() => connectGoogleCalendar(clinicId).catch(error=>notify({type:"error",title:"Google Calendar",message:error.message}))}

                          style={{
                              height:52,
                              border:"none",
                              borderRadius:14,
                              background:"#2563eb",
                              color:"#fff",
                              fontWeight:700,
                              fontSize:15,
                              cursor:"pointer",

                              display:"flex",
                              alignItems:"center",
                              justifyContent:"center",
                              gap:10,
                              transition:".2s"
                          }}

                        >

                          <>
                              <Link2 size={18} />
                              Conectar Google Calendar
                          </>

                        </button>

                      )

                    }

                    {

                      googleCalendarStatus.connected && (

                        <>

                          <button

                            onClick={importarEventosGoogle}

                            disabled={importandoGoogle}

                            style={{
                              height:52,
                              border:"none",
                              borderRadius:14,
                              background:
                                importandoGoogle
                                  ? "#94a3b8"
                                  : "#16a34a",
                              color:"#fff",
                              fontWeight:700,
                              fontSize:15,
                              cursor:
                                importandoGoogle
                                  ? "default"
                                  : "pointer",
                              display:"flex",
                              alignItems:"center",
                              justifyContent:"center",
                              gap:10,
                              transition:".2s",
                            }}

                          >

                            <>

                                <Download size={18}/>

                                {

                                    importandoGoogle
                                        ? "Importando..."
                                        : "Importar eventos existentes"

                                }

                            </>

                          </button>

                          <button

                            onClick={desconectarGoogleCalendar}

                            style={{
                              height:48,
                              border:"none",
                              borderRadius:14,
                              background:"#dc2626",
                              color:"#fff",
                              fontWeight:700,
                              fontSize:15,
                              cursor:"pointer",
                              display:"flex",
                              alignItems:"center",
                              justifyContent:"center",
                              gap:10,
                              transition:".2s",
                            }}

                          >

                            <>

                                <Unplug size={18}/>

                                Desconectar Google Calendar

                            </>

                          </button>

                        </>

                      )

                    }

                  </div>

                </div>

              </div>

            </div>

        )}

        {
          settingsTab ===
          "notificaciones" && (

            <div
              style={{
                background:"#fff",
                padding:24,
                borderRadius:24,
                maxWidth:1000
              }}
            >

              <h2>
                Notificaciones
              </h2>

              <div
                style={{
                  display:"flex",
                  flexDirection:"column",
                  gap:18
                }}
              >

                {[
                  [
                    "reminder24h",
                    "Recordatorio 24 horas antes"
                  ],

                  [
                    "reminder2h",
                    "Recordatorio 2 horas antes"
                  ],

                  [
                    "autoConfirm",
                    "Confirmación automática"
                  ],

                  [
                    "cancelledAppointment",
                    "Citas canceladas"
                  ],

                  [
                    "whatsappMessages",
                    "Mensajes de WhatsApp"
                  ]

                ].map(([key,label]) => (

                  <label
                    key={key}
                    style={{
                      display:"flex",
                      gap:10,
                      fontWeight:600
                    }}
                  >

                    <input
                      type="checkbox"
                      checked={
                        form.notifications?.[
                          key
                        ]
                      }
                      onChange={e =>

                        setForm(
                          prev => ({

                            ...prev,

                            notifications: {

                              ...prev.notifications,

                              [key]:
                                e.target.checked

                            }

                          })

                        )

                      }
                    />

                    {label}

                  </label>

                ))}

              </div>

            </div>

        )}

        {settingsTab === "cuenta" && (
          <section className="vd-settings-account vd-settings-module">
            <div className="vd-settings-module-header">
              <div>
                <p className="vd-settings-module-kicker">Acceso personal</p>
                <h2>Cuenta y seguridad</h2>
                <p>Controla tu identidad, firma clínica y protección de acceso en un solo lugar.</p>
              </div>
              <span className="vd-settings-module-badge"><ShieldCheck size={14} /> Cuenta protegida</span>
            </div>

            <div className="vd-settings-account-grid">
              <div className="vd-settings-account-card vd-settings-account-identity">
                <div className="vd-settings-card-label">Sesión actual</div>
                <strong>{auth.currentUser?.displayName || "Usuario VexaDent"}</strong>
                <span>{auth.currentUser?.email || "Sin correo disponible"}</span>
                <small>Usa este correo para ingresar a tu cuenta.</small>
              </div>
              <div className="vd-settings-account-card">
                <div className="vd-settings-card-label">Seguridad</div>
                <strong>Contraseña de acceso</strong>
                <span>Actualiza tu contraseña cuando lo necesites.</span>
                <button className="vd-settings-primary-button" type="button" onClick={() => setShowPasswordModal(true)}>
                  Cambiar contraseña <ChevronRight size={15} />
                </button>
              </div>
            </div>

            <div className="vd-settings-account-card vd-settings-signature-card">
              <div className="vd-settings-section-heading">
                <div>
                  <p className="vd-settings-module-kicker">Documentos clínicos</p>
                  <h3>Firma personalizada</h3>
                  <span>Se usará en documentos y comunicaciones donde corresponda.</span>
                </div>
                <FileSignature size={22} />
              </div>
              <textarea
                rows={4}
                value={userSettings.firmaPersonalizada}
                onChange={e => setUserSettings({ ...userSettings, firmaPersonalizada: e.target.value })}
                placeholder="Ej. Dra. Ana López · Cédula profesional..."
              />
              <label className="vd-settings-check-row">
                <input
                  type="checkbox"
                  checked={userSettings.useCustomSignature}
                  onChange={e => setUserSettings({ ...userSettings, useCustomSignature: e.target.checked })}
                />
                <span><strong>Usar esta firma en mis documentos</strong><small>Si la desactivas, VexaDent utilizará la firma estándar del consultorio.</small></span>
              </label>
            </div>
          </section>
        )}

        {settingsTab === "sistema" && (
          <section className="vd-settings-system vd-settings-module">
            <div className="vd-settings-module-header">
              <div>
                <p className="vd-settings-module-kicker">Salud de la plataforma</p>
                <h2>Sistema</h2>
                <p>Consulta conexiones, versión y acceso móvil sin entrar a pantallas técnicas.</p>
              </div>
              <span className="vd-settings-module-badge"><Activity size={14} /> Estado en tiempo real</span>
            </div>

            <div className="vd-settings-system-grid">
              <div className="vd-settings-system-card"><span className="vd-settings-status-dot is-on" /><div><small>Aplicación</small><strong>Operativa</strong></div></div>
              <div className="vd-settings-system-card"><span className={`vd-settings-status-dot ${vpsOnline ? "is-on" : "is-off"}`} /><div><small>WhatsApp VPS</small><strong>{vpsOnline ? "En línea" : "Sin conexión"}</strong></div></div>
              <div className="vd-settings-system-card"><span className={`vd-settings-status-dot ${whatsappStatus?.connected ? "is-on" : "is-off"}`} /><div><small>Sesión WhatsApp</small><strong>{whatsappStatus?.connected ? "Conectada" : "Desconectada"}</strong></div></div>
              <div className="vd-settings-system-card"><span className={`vd-settings-status-dot ${googleCalendarStatus.connected ? "is-on" : "is-off"}`} /><div><small>Google Calendar</small><strong>{googleCalendarStatus.connected ? "Conectado" : "Desconectado"}</strong></div></div>
            </div>

            <div className="vd-settings-system-details">
              <div className="vd-settings-account-card">
                <div className="vd-settings-card-label">Información técnica</div>
                <div className="vd-settings-detail-row"><span>Versión instalada</span><strong>1.0.5</strong></div>
                <div className="vd-settings-detail-row"><span>Base de datos</span><strong className="is-success">Conectada</strong></div>
                <div className="vd-settings-detail-row"><span>Número de WhatsApp</span><strong>{whatsappStatus?.phoneNumber || "No configurado"}</strong></div>
              </div>
              <button className="vd-settings-mobile-card" type="button" onClick={() => setShowMobileAppModal(true)}>
                <span className="vd-settings-mobile-card-icon"><QrCode size={21} /></span>
                <span><strong>Instalar VexaDent en otro dispositivo</strong><small>Escanea un QR y continúa trabajando desde móvil.</small></span>
                <ChevronRight size={18} />
              </button>
            </div>
          </section>
        )}

        <div
          style={{

            position:"sticky",

            bottom:20,

            display: [
              "overview",
              "control",
              "integraciones",
              "comunicacion",
              "procedures",
              "medicamentos",
              "consentimientos",
              "sistema"
            ].includes(settingsTab) ? "none" : "flex",

            justifyContent:"flex-end",

            marginTop:20,

            zIndex:1000,

            pointerEvents:"none"

          }}
        >

          <button

            onClick={async () => {

              if (settingsTab === "historiaClinica" && historiaClinicaSave) {

                await historiaClinicaSave();

              } else if (settingsTab === "comunicacion") {

                if (comunicacionSaveRef.current) {
                  await comunicacionSaveRef.current();
                }

              } else {

                await guardar();

              }

            }}

            disabled={
              settingsTab === "historiaClinica"
                ? historiaClinicaSaving
                : saving
            }

            style={{

              width:240,

              padding:"16px",

              border:"none",

              borderRadius:16,

              background:"#2563eb",

              color:"#fff",

              fontWeight:700,

              cursor:
                (
                  settingsTab === "historiaClinica"
                    ? historiaClinicaSaving
                    : saving
                )
                  ? "not-allowed"
                  : "pointer",

              opacity:
                (
                  settingsTab === "historiaClinica"
                    ? historiaClinicaSaving
                    : saving
                )
                  ? 0.6
                  : 1,

              boxShadow:
                "0 10px 25px rgba(0,0,0,.15)",

              pointerEvents:"all"

            }}

          >

            {

              (
                settingsTab === "historiaClinica"
                  ? historiaClinicaSaving
                  : saving
              )

                ? "Guardando..."

                : "Guardar cambios"

            }

          </button>

        </div>

          </main>
        </div>
      </div>

    {
      showMobileAppModal && (

        <div
          style={{
            position:"fixed",
            inset:0,
            background:
              "rgba(0,0,0,.5)",
            display:"flex",
            justifyContent:
              "center",
            alignItems:
              "center",
            zIndex:99999
          }}
        >

          <div
            style={{
              width:500,
              background:"#fff",
              borderRadius:20,
              padding:24
            }}
          >

            <h2>

              Aplicación móvil

            </h2>

            <div
              style={{
                color:"#64748b",
                marginBottom:20
              }}
            >

              Instala VexaDent en todos
              tus dispositivos utilizando
              tu cuenta.

            </div>

            <div
              style={{
                display:"flex",
                justifyContent:"center",
                marginBottom:20
              }}
            >

              <QRCodeSVG
                value="https://app.vexadent.com"
                size={220}
              />

            </div>

            <div
              style={{
                textAlign:"center",
                fontWeight:700,
                marginBottom:20
              }}
            >

              https://app.vexadent.com

            </div>

            <div
              style={{
                marginBottom:20
              }}
            >

              <strong>
                Android
              </strong>

              <br />

              • Escanea el QR.

              <br />

              • Presiona Instalar.

            </div>

            <div
              style={{
                marginBottom:20
              }}
            >

              <strong>
                iPhone
              </strong>

              <br />

              • Escanea el QR.

              <br />

              • Compartir.

              <br />

              • Agregar a pantalla
              de inicio.

            </div>

            <button

              onClick={() =>
                setShowMobileAppModal(
                  false
                )
              }

              style={{
                width:"100%",
                padding:14,
                border:"none",
                borderRadius:12,
                background:"#2563eb",
                color:"#fff",
                fontWeight:700,
                cursor:"pointer"
              }}

            >

              Cerrar

            </button>

          </div>

        </div>

    )}

    {
    showPasswordModal && (

    <div
      style={{
        position:"fixed",
        inset:0,
        background:
          "rgba(0,0,0,.5)",
        display:"flex",
        justifyContent:
          "center",
        alignItems:
          "center",
        zIndex:99999
      }}
    >

      <div
        style={{
          width:450,
          background:"#fff",
          borderRadius:20,
          padding:24,
          display:"flex",
          flexDirection:
            "column",
          gap:16
        }}
      >

        <h2
          style={{
            margin:0
          }}
        >
          Cambiar contraseña
        </h2>

        <div
          style={{
            position: "relative"
          }}
        >

          <input
            type={
              showCurrentPassword
                ? "text"
                : "password"
            }
            placeholder="Contraseña actual"
            value={currentPassword}
            onChange={e =>
              setCurrentPassword(
                e.target.value
              )
            }
            style={{
              ...inputStyle,
              paddingRight: 50
            }}
          />

          <div
            onClick={() =>
              setShowCurrentPassword(
                !showCurrentPassword
              )
            }
            style={{
              position: "absolute",
              right: 15,
              top: "50%",
              transform:
                "translateY(-50%)",
              cursor: "pointer",
              color: "#64748b"
            }}
          >
            {
              showCurrentPassword
                ? <FaEyeSlash size={18} />
                : <FaEye size={18} />
            }
          </div>

        </div>

        <div
          style={{
            position: "relative"
          }}
        >

          <input
            type={
              showNewPassword
                ? "text"
                : "password"
            }
            placeholder="Nueva contraseña"
            value={newPassword}
            onChange={e =>
              setNewPassword(
                e.target.value
              )
            }
            style={{
              ...inputStyle,
              paddingRight: 50
            }}
          />

          <div
            onClick={() =>
              setShowNewPassword(
                !showNewPassword
              )
            }
            style={{
              position: "absolute",
              right: 15,
              top: "50%",
              transform:
                "translateY(-50%)",
              cursor: "pointer",
              color: "#64748b"
            }}
          >
            {
              showNewPassword
                ? <FaEyeSlash size={18} />
                : <FaEye size={18} />
            }
          </div>

        </div>

        <div
          style={{
            position: "relative"
          }}
        >

          <input
            type={
              showConfirmPassword
                ? "text"
                : "password"
            }
            placeholder="Confirmar contraseña"
            value={confirmPassword}
            onChange={e =>
              setConfirmPassword(
                e.target.value
              )
            }
            style={{
              ...inputStyle,
              paddingRight: 50
            }}
          />

          <div
            onClick={() =>
              setShowConfirmPassword(
                !showConfirmPassword
              )
            }
            style={{
              position: "absolute",
              right: 15,
              top: "50%",
              transform:
                "translateY(-50%)",
              cursor: "pointer",
              color: "#64748b"
            }}
          >
            {
              showConfirmPassword
                ? <FaEyeSlash size={18} />
                : <FaEye size={18} />
            }
          </div>

        </div>

        <div
          style={{
            fontSize:13,
            color:"#64748b"
          }}
        >
          • 8 caracteres<br/>
          • Una mayúscula<br/>
          • Una minúscula<br/>
          • Un número<br/>
          • Un caracter especial
        </div>

        <div
          style={{
            display:"flex",
            gap:10
          }}
        >

          <button
            onClick={() =>
              setShowPasswordModal(
                false
              )
            }
            style={{
              flex:1,
              padding:12,
              borderRadius:12
            }}
          >
            Cancelar
          </button>

          <button
            onClick={
              cambiarPassword
            }
            style={{
              flex:1,
              padding:12,
              border:"none",
              borderRadius:12,
              background:"#2563eb",
              color:"#fff"
            }}
          >
            Guardar
          </button>

        </div>

      </div>

    </div>

    )}

  </>

  );

}
